import React from "react";
import Popup from "./index";
import { MdWarning, MdInfo, MdError } from "react-icons/md";

interface ConfirmPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "default" | "danger" | "warning";
}

const ConfirmPopup: React.FC<ConfirmPopupProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "default",
}) => {
  const getIcon = () => {
    switch (variant) {
      case "danger":
        return <MdError className="h-12 w-12 text-red-500" />;
      case "warning":
        return <MdWarning className="h-12 w-12 text-yellow-500" />;
      default:
        return <MdInfo className="h-12 w-12 text-brand-500" />;
    }
  };

  const getConfirmButtonClass = () => {
    switch (variant) {
      case "danger":
        return "bg-red-500 hover:bg-red-600";
      case "warning":
        return "bg-yellow-500 hover:bg-yellow-600";
      default:
        return "bg-brand-500 hover:bg-brand-600";
    }
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      showCloseButton={false}
      closeOnBackdropClick={false}
    >
      <div className="flex flex-col items-center text-center">
        {/* Icon */}
        <div className="mb-4">{getIcon()}</div>

        {/* Message */}
        <p className="mb-6 whitespace-pre-line text-base text-gray-700 dark:text-gray-300">
          {message}
        </p>

        {/* Buttons */}
        <div className="flex w-full gap-3">
          <button
            onClick={onClose}
            className="flex-1 rounded-lg border border-gray-300 px-4 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-white/10 dark:text-gray-300 dark:hover:bg-white/5"
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            className={`flex-1 rounded-lg px-4 py-2.5 text-sm font-medium text-white transition-colors ${getConfirmButtonClass()}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Popup>
  );
};

export default ConfirmPopup;
